module.exports = __webpack_public_path__ + "img/4e6f4aa.png";